import { IProductRepository } from '../../../domain/repositories/IProductRepository';
import { Product } from '../../../domain/entities/Product';
import { ValidationError } from '../../../core/errors/DomainErrors';

export interface UpdateProductDTO {
    id: string;
    name?: string;
    value?: number;
    description?: string;
    organizationId: string;
}

export class UpdateProductUseCase {
    constructor(private readonly productRepository: IProductRepository) { }

    async execute(dto: UpdateProductDTO): Promise<Product> {
        // Busca produto existente
        const existingProduct = await this.productRepository.findById(dto.id);

        if (!existingProduct) {
            throw new ValidationError('Produto não encontrado');
        }

        // Atualiza campos se fornecidos
        if (dto.name !== undefined) {
            existingProduct.updateName(dto.name);
        }

        if (dto.value !== undefined) {
            existingProduct.updateValue(dto.value);
        }

        if (dto.description !== undefined) {
            existingProduct.updateDescription(dto.description);
        }

        // Persiste atualização
        const updatedProduct = await this.productRepository.save(existingProduct, dto.organizationId);

        return updatedProduct;
    }
}
